import { isValidPhoneNumber } from 'libphonenumber-js';

/**
 * Valida un teléfono en formato internacional E.164 (ej: "+56912345678").
 * Devuelve el mensaje de error o `null` si es válido.
 * - Vacío: error solo si es requerido.
 * - Con valor: debe ser un número válido para el país de su prefijo.
 */
export const validarTelefono = (value: string, required: boolean): string | null => {
  const v = value.trim();
  if (!v) return required ? 'Campo requerido' : null;
  return isValidPhoneNumber(v) ? null : 'Teléfono inválido';
};
